<template>
  <div class="app-shell min-h-screen">
    <div class="mx-auto max-w-[1600px] px-4 py-4 md:px-6 md:py-6">
      <header class="app-masthead rounded-[2rem] px-6 py-6 md:px-8">
        <div class="flex flex-col gap-6 lg:flex-row lg:items-center lg:justify-between">
          <div class="flex items-center gap-4">
            <div class="brand-mark brand-mark--dark">
              <span class="brand-mark__ring"></span>
              <span class="brand-mark__core">E</span>
            </div>
            <div>
              <div class="text-[0.72rem] font-semibold uppercase tracking-[0.42em] text-white/45">Curated Console</div>
              <div class="mt-1 font-display text-4xl font-black tracking-[0.16em] text-white">E品通</div>
            </div>
          </div>
          <div class="flex items-center gap-3 self-start lg:self-auto">
            <div class="rounded-full border border-white/10 bg-white/8 px-4 py-2 text-sm font-semibold text-white/90 backdrop-blur-sm">
              {{ currentUser?.nickname || '未登录' }} / {{ currentUser?.role || '-' }}
            </div>
            <button class="btn btn-ghost" @click="logout">退出登录</button>
          </div>
        </div>
        <div class="mt-6 flex flex-col gap-4 xl:flex-row xl:items-end xl:justify-between">
          <div class="min-w-0">
            <div class="text-[0.72rem] font-semibold uppercase tracking-[0.36em] text-white/35">Workspace</div>
            <div class="mt-2 text-2xl font-bold tracking-[0.02em] text-white">{{ pageTitle }}</div>
          </div>
          <nav class="flex flex-wrap gap-2">
          <router-link
            v-for="item in menus"
            :key="item.path"
            :to="item.path"
            class="nav-pill"
            active-class="nav-pill nav-pill--active"
          >
            {{ item.label }}
          </router-link>
        </nav>
        </div>
      </header>

      <main class="mt-6 min-w-0">
        <router-view />
      </main>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { clearToken, getUser } from '@/utils/auth';

const route = useRoute();
const router = useRouter();
const currentUser = getUser();

const menus = computed(() => {
  const items = [
    { path: '/dashboard', label: '仪表盘' },
    { path: '/products', label: '产品生成' },
    { path: '/prompts', label: '提示词库' },
    { path: '/etsy-records', label: 'Etsy记录' },
    { path: '/etsy-shipping-profiles', label: 'Etsy运费' }
  ];
  if (currentUser && currentUser.role === 'ADMIN') {
    items.push({ path: '/variation-templates', label: '变量字典' });
    items.push({ path: '/settings', label: '安全配置' });
    items.push({ path: '/users', label: '用户管理' });
  }
  return items;
});

const pageTitle = computed(() => {
  const map = {
    '/dashboard': '运行总览',
    '/products': '产品生成与导出',
    '/prompts': '提示词资产库',
    '/etsy-records': 'Etsy 发布记录',
    '/etsy-shipping-profiles': 'Etsy 运费模板',
    '/variation-templates': '变量字典模板',
    '/settings': '安全配置中心',
    '/users': '用户与权限'
  };
  return map[route.path] || 'E品通';
});

function logout() {
  clearToken();
  router.push('/login');
}
</script>
